<template>
    <a-modal v-model="visible" title="资信专业信息" width="35%" centered :maskClosable="false" :keyboard="false" class="diyModelCls">
        <a-spin :spinning="loading">
            <vxe-toolbar size="mini">
                <template v-slot:tools>
                    <a-button type="primary" :loading="saving || loading" @click="insertItem">增行</a-button>
                </template>
            </vxe-toolbar>
            <vxe-table
                ref="itemTable"
                size="mini"
                resizable
                keep-source
                auto-resize
                row-id="id"
                align="left"
                header-align="center"
                highlight-hover-row
                highlight-current-row
                show-overflow="tooltip"
                :data="editItemData"
                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
            >
                <vxe-table-column type="seq" title="序号" width="70" align="center"
                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.xh" /> </template>
                </vxe-table-column>
                <FGDataSelect :isShow.sync="isShow_zymc" selectNo="ZX100101" @saveselect="saveEvent_zymc(arguments, editItemData)"> </FGDataSelect>
                <vxe-table-column field="zymc" title="专业(业务)名称" min-width="260" :edit-render="{ type: 'default', autofocus: 'input' }">
                    <template v-slot:edit="scope">
                        <a-input-search size="small" ref="zymc" readOnly @search="search_zymc(scope.row)" v-model="scope.row.zymc" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="bz"
                    title="备注"
                    width="180"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.bz" />
                    </template>
                </vxe-table-column>
                <vxe-table-column title="操作" width="70" align="center">
                    <template v-slot="scope">
                        <span class="btn_edit" @click="removeItem(scope.row)">删除</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "ZyxxEdit",
    props: ["showMxEdit", "dataId", "zxdjbgid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editItemData: [],
            editDataLoading: false,
            editProps: {
                showMxEdit: false,
                zxdjbgid: null
            },
            isShow_zymc: false
        };
    },
    computed: {
        visible: {
            get() {
                return this.showMxEdit;
            },
            set(newVal) {
                this.$emit("update:showMxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    if (!this.dataId) {
                        // 新增，设置默认值
                        this.editData = {
                            id: this.$FG_util.uuid(),
                            isnew: true,
                            bgsqbid: this.dataId,
                            zxdjbgid: this.zxdjbgid,
                            ydjbj: 0
                        };
                    } else {
                        // 修改，加载数据
                        this.loadItemData();
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwzxbg/listItemZYXX",
                    {
                        zxdjbgid: this.zxdjbgid,
                        sort: {
                            field: "XH",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增明细
        insertItem() {
            // 设置编辑记录
            this.$refs.itemTable
                .insertAt(
                    {
                        id: this.$FG_util.uuid(),
                        isnew: true,
                        bgsqbid: this.dataId,
                        zxdjbgid: this.zxdjbgid,
                        ydjbj: 0,
                        xh: this.$refs.itemTable.data.length + this.$refs.itemTable.getInsertRecords().length + 1
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemTable.setActiveRow(row);
                });
        },
        search_zymc(row) {
            this.isShow_zymc = true;
            this.select_zymc = row;
        },
        saveEvent_zymc(val, row) {
            if (val && val.length > 0) {
                this.select_zymc.zyid = val[0][0].ID;
                this.select_zymc.zymc = val[0][0].ZYYWLY;
                this.select_zymc.zxlb = val[0][0].ZXLB;
            }
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        //提交form
        onSave() {
            let itemData = this.$refs.itemTable.getInsertRecords().concat(this.$refs.itemTable.getUpdateRecords());
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post("./api/main/zxdw/dwzxbg/saveZYXX", {
                    itemData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.editData.id);
                    } else {
                        this.$refs.zymc.focus();
                    }
                });
        },
        // 删除明细
        removeItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zxdw/dwzxbg/deleteZyxxMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadItemData();
                                }
                            });
                    }
                }
            });
        }
    }
};
</script>
